import React from 'react';
import { CAREER_MODAL_NAME } from 'src/app/shared/components/modals/career/const';
import { useModal } from 'src/shared/modalProvider';
import { useSpecialistRegistrationCareer } from './useSpecialistRegistrationCareer';

export const useRegistrationForSpecialist = () => {
  const { openModal } = useModal();
  const onCareerSelected = useSpecialistRegistrationCareer();

  return React.useCallback(() => {
    openModal(CAREER_MODAL_NAME, {
      title: 'Ищу работу',
      onCareerSelected,
    });
  }, [openModal, onCareerSelected]);
};
